import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ApiService from "../../../ApiService";
import TextField from "@material-ui/core/TextField";
import Button from "../../../components/Custom/Button/Button";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Alert } from "@mui/material";
import MaterialTable from "../../../components/MaterialTable";
import Divider from "@material-ui/core/Divider";
import TableIcons from "../../common/TableLogoComponent";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
} from "@material-ui/core";

class TabPanel extends Component {
  render() {
    const { children, value, index, ...other } = this.props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`merchant-tabpanel-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
}

const useStyles = (theme) => ({
  searchbar: {
    margin: theme.spacing(2),
  },
  formControl: {
    minWidth: 200,
  },
});

class AddMerchantUrlComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchantUrls: [],
      merchantIps: [],
      failed: false,
      success: false,
      responsemessage: null,
      url: null,
      ip: null,
      tabValue: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.addMerchantUrl = this.addMerchantUrl.bind(this);
    this.addMerchantIp = this.addMerchantIp.bind(this);
  }
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      critChanged: true,
    });
  }

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };
  componentDidMount() {
    this.reloadData();
  }
  reloadData() {
    ApiService.fetchMerchantUrls(this.props.merchantId).then((res) => {
      //alert("re.data" + res.data);
      this.setState({ merchantUrls: res.data });
    });
    ApiService.fetchMerchantIps(this.props.merchantId).then((res) => {
      //alert("re.data" + res.data);
      this.setState({ merchantIps: res.data });
    });
  }

  addMerchantUrl() {
    if (this.state.url === null || this.state.url === "") {
      this.setState({
        failed: true,
        success: false,
        responsemessage: "Url cannot be empty",
      });
    } else {
      ApiService.addMerchantUrl(this.props.merchantId, this.state.url)
        .then((res) => {
          if (res.data.status === "OK") {
            this.reloadData();
            this.setState({
              success: true,
              failed: false,
              responsemessage: res.data.responseMessage,
            });
          } else {
            this.setState({
              failed: true,
              success: false,
              responsemessage: res.data.responseMessage,
            });
          }
        })
        .catch((e) => {
          this.setState({ failed: true, success: false, responsemessage: e });
        });
    }
  }

  addMerchantIp() {
    if (this.state.ip === null || this.state.ip === "") {
      this.setState({
        failed: true,
        success: false,
        responsemessage: "IP cannot be empty",
      });
    } else {
      ApiService.addMerchantIp(this.props.merchantId, this.state.ip)
        .then((res) => {
          if (res.data.status === "OK") {
            this.reloadData();
            this.setState({
              success: true,
              failed: false,
              responsemessage: res.data.responseMessage,
            });
          } else {
            this.setState({
              failed: true,
              success: false,
              responsemessage: res.data.responseMessage,
            });
          }
        })
        .catch((e) => {
          this.setState({ failed: true, success: false, responsemessage: e });
        });
    }
  }

  removeMerchantUrl(data) {
    ApiService.removeMerchantUrl(this.props.merchantId, data.id)
      .then((res) => {
        this.reloadData();
        this.setState({
          success: true,
          failed: false,
          responsemessage: res.data.responseMessage,
        });
      })
      .catch((e) => {
        this.setState({ failed: true, success: false, responsemessage: e });
      });
  }

  removeMerchantIp(data) {
    ApiService.removeMerchantIp(this.props.merchantId, data.id)
      .then((res) => {
        this.reloadData();
        this.setState({
          success: true,
          failed: false,
          responsemessage: res.data.responseMessage,
        });
      })
      .catch((e) => {
        this.setState({ failed: true, success: false, responsemessage: e });
      });
  }

  render() {
    const { classes } = this.props;
    // const { selectedCountry } = this.state;
    const { tabValue, url, ip, merchantUrls, merchantIps } = this.state;

    return (
      <Paper>
        {this.state.failed && (
          <Alert severity="error" elevation="0">
            {" "}
            {this.state.responsemessage}
          </Alert>
        )}
        {this.state.success && (
          <Alert severity="success" elevation="0">
            {" "}
            {this.state.responsemessage}
          </Alert>
        )}

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabValue}
              onChange={this.handleTabChange}
              aria-label="merchant management tabs"
            >
              <Tab label="Merchant URL" />
              <Tab label="Merchant IPs" />
            </Tabs>
          </Box>

          {/* URL Tab */}
          <TabPanel value={tabValue} index={0}>
            <Box sx={{ mb: 2 }}>
              <TextField
                id="url"
                name="url"
                label="Merchant URL"
                value={url}
                onChange={this.handleChange}
                sx={{ mr: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={this.addMerchantUrl}
                sx={{ ml: 2, mt: 1.5 }}
              >
                Add URL
              </Button>
            </Box>
            <MaterialTable
              title="Merchant URLs"
              icons={TableIcons.icons}
              columns={[{ field: "url", numeric: false, title: "URL" }]}
              data={merchantUrls}
              actions={[
                {
                  tooltip: "Delete URL",
                  icon: (props) => <DeleteIcon {...props} />,
                  onClick: (evt, data) => this.removeMerchantUrl(data),
                },
              ]}
              options={{
                search: false,
                exportButton: false,
                pageSize: 10,
                pageSizeOptions: [10, 20],
                padding: "dense",
                showEmptyDataSourceMessage: true,
                emptyRowsWhenPaging: false,
              }}
            />
          </TabPanel>

          {/* IP Tab */}
          <TabPanel value={tabValue} index={1}>
            <Box sx={{ mb: 2 }}>
              <TextField
                id="ip"
                name="ip"
                label="Merchant IP"
                value={ip}
                onChange={this.handleChange}
                sx={{ mr: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={this.addMerchantIp}
                sx={{ ml: 2, mt: 1.5 }}
              >
                Add IP
              </Button>
            </Box>
            <MaterialTable
              title="Merchant IPs"
              icons={TableIcons.icons}
              columns={[{ field: "ip", numeric: false, title: "IP" }]}
              data={merchantIps}
              actions={[
                {
                  tooltip: "Delete IP",
                  icon: (props) => <DeleteIcon {...props} />,
                  onClick: (evt, data) => this.removeMerchantIp(data),
                },
              ]}
              options={{
                search: false,
                exportButton: false,
                pageSize: 10,
                pageSizeOptions: [10, 20],
                padding: "dense",
                showEmptyDataSourceMessage: true,
                emptyRowsWhenPaging: false,
              }}
            />
          </TabPanel>
        </Box>
      </Paper>
    );
  }
}

export default withStyles(useStyles)(AddMerchantUrlComponent);
